var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "My Push" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "filter-wrapper",
                  attrs: { "label-width": "60px" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "HCP Name",
                            prop: "role",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "month-select",
                              attrs: { placeholder: "Please select hcp name" },
                              on: { change: _vm.onSearch },
                              model: {
                                value: _vm.seId,
                                callback: function ($$v) {
                                  _vm.seId = $$v
                                },
                                expression: "seId",
                              },
                            },
                            _vm._l(_vm.seIdList, function (se, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: { label: se.Name, value: se.SEID },
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        width: "100%",
                                        trigger: "hover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "max-width": "300px" },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v("Name：" + _vm._s(se.Name)),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "Province：" + _vm._s(se.Province)
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("City：" + _vm._s(se.City)),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "Hospital/Institution：" +
                                                _vm._s(se.Hospital)
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "Department：" +
                                                _vm._s(se.Department)
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "se-name" },
                                            [_vm._v(_vm._s(se.Name))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Request Type",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "month-select",
                              attrs: { placeholder: "Please select type" },
                              on: { change: _vm.onSearch },
                              model: {
                                value: _vm.oneTimeRequest,
                                callback: function ($$v) {
                                  _vm.oneTimeRequest = $$v
                                },
                                expression: "oneTimeRequest",
                              },
                            },
                            _vm._l(
                              _vm.oneTimeRequestList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.value, value: item.key },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Status" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "month-select",
                              attrs: { placeholder: "Please select type" },
                              on: { change: _vm.onSearch },
                              model: {
                                value: _vm.status,
                                callback: function ($$v) {
                                  _vm.status = $$v
                                },
                                expression: "status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.statusdesc,
                                  value: item.status,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-input", {
                    directives: [
                      {
                        name: "debounce",
                        rawName: "v-debounce",
                        value: _vm.onSearch,
                        expression: "onSearch",
                      },
                    ],
                    staticStyle: { width: "120px", margin: "0 10px" },
                    attrs: {
                      "prefix-icon": "el-icon-search",
                      placeholder: "Search",
                      clearable: "",
                    },
                    on: { clear: _vm.onSearch },
                    model: {
                      value: _vm.searchVal,
                      callback: function ($$v) {
                        _vm.searchVal = $$v
                      },
                      expression: "searchVal",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "role",
                          rawName: "v-role",
                          value: [2, 3, 5, 7, 9, 11, 13],
                          expression: "[2, 3, 5, 7, 9, 11, 13]",
                        },
                      ],
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: {
                        click: function ($event) {
                          return _vm.openCombinePushDialog()
                        },
                      },
                    },
                    [_vm._v(" Create Push ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "role",
                          rawName: "v-role",
                          value: [2, 3, 13],
                          expression: "[2, 3, 13]",
                        },
                      ],
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: {
                        click: function ($event) {
                          return _vm.handleMeetingPush()
                        },
                      },
                    },
                    [_vm._v(" Create Meeting Push ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          staticClass: "push-module-tabs",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "My Push", name: "list" } }),
          _c("el-tab-pane", { attrs: { name: "progress" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm._v(" Batch Progress "),
                _vm.sendingBadgeCount > 0
                  ? _c("el-badge", {
                      staticClass: "progress-tab-badge",
                      attrs: { value: _vm.sendingBadgeCount },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.activeTab === "progress"
        ? _c("BatchProgressTab", { on: { summary: _vm.onBatchSummary } })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "list",
              expression: "activeTab === 'list'",
            },
          ],
          staticClass: "table-wrapper",
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "SeTable",
              attrs: {
                data: _vm.tableData,
                "row-key": "MessageHeadID",
                "element-loading-text": "Loading...",
              },
              on: { "sort-change": _vm.onSortChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand", width: "20px", fixed: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.IsBatchPushDraft
                          ? _c("expand-for-draft", {
                              attrs: {
                                label: _vm.nameLabel,
                                "batch-id": row.BatchID,
                                "request-info": row.RequestInfo,
                              },
                            })
                          : _c("expand-for-pushed", {
                              attrs: { label: _vm.nameLabel, row: row },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "No",
                  fixed: "",
                  label: "No.",
                  sortable: "custom",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "PushMessage",
                  fixed: "",
                  label: "Push Message",
                  sortable: "custom",
                  "min-width": "165",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(row.PushMessage) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "PushTypeName",
                  fixed: "",
                  label: "Push Type",
                  sortable: "custom",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "SeName",
                  fixed: "",
                  label: _vm.columnNameLabel,
                  "min-width": "100",
                  sortable: "custom",
                },
              }),
              _vm.shouldShowColumn
                ? _c("el-table-column", {
                    attrs: {
                      prop: "Types",
                      fixed: "",
                      label: "Type",
                      width: "80",
                      sortable: "Type",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "Hits", label: "Hits", sortable: "custom" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "LastViewDate",
                  label: "Last View Time",
                  width: "165",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "ItemCount", label: "Item", sortable: "custom" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row, $index }) {
                      return [
                        row.ItemCount > 0
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  width: "400",
                                  trigger: "hover",
                                },
                                on: {
                                  show: function ($event) {
                                    return _vm.showItem(row, $index)
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-table",
                                  { attrs: { data: row.item, height: "200" } },
                                  [
                                    _c("el-table-column", {
                                      attrs: { prop: "File", label: "File" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "Duration",
                                        label: "Duration(s)",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: { prop: "Hits", label: "Hits" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "Download",
                                        label: "Download",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "crp-more",
                                    attrs: {
                                      slot: "reference",
                                      type: "warning",
                                      effect: "dark",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(" " + _vm._s(row.ItemCount) + " "),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "el-tag",
                              {
                                staticClass: "crp-more",
                                attrs: {
                                  slot: "reference",
                                  type: "warning",
                                  effect: "dark",
                                },
                                slot: "reference",
                              },
                              [
                                _vm._v(" " + _vm._s(row.ItemCount) + " "),
                                _c("i", { staticClass: "el-icon-arrow-down" }),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Adandam",
                  label: "Comment",
                  sortable: "custom",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", {
                          staticClass: "reduce-adandam",
                          domProps: { innerHTML: _vm._s(row.Adandam) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "90",
                  prop: "StatusDesc",
                  label: "Status",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Pushed Date",
                  "min-width": "145",
                  prop: "SentOn",
                  sortable: "custom",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Like or Dislike",
                  "min-width": "145",
                  prop: "LikeOrDislike",
                  sortable: "custom",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Focus Area",
                  "min-width": "145",
                  prop: "FocusArea",
                  sortable: "custom",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Operation",
                  "min-width": "115",
                  prop: "StatusDesc",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.Status === 0
                          ? _c(
                              "OptionMenu",
                              {
                                attrs: {
                                  icon: "iconfont icon-more-menu",
                                  iconSize: "18",
                                },
                              },
                              [
                                [
                                  _c("OptionMenuItem", {
                                    directives: [
                                      {
                                        name: "role",
                                        rawName: "v-role",
                                        value: [2, 3, 5, 7, 9, 11, 13],
                                        expression: "[2, 3, 5, 7, 9, 11, 13]",
                                      },
                                    ],
                                    attrs: {
                                      icon: "el-icon-edit",
                                      title: "Edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  }),
                                  _c("OptionMenuItem", {
                                    attrs: {
                                      icon: "el-icon-upload2",
                                      title: "Submit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSubmit(row)
                                      },
                                    },
                                  }),
                                  _c("OptionMenuItem", {
                                    directives: [
                                      {
                                        name: "role",
                                        rawName: "v-role",
                                        value: [2, 3, 5, 7, 9, 11, 13],
                                        expression: "[2, 3, 5, 7, 9, 11, 13]",
                                      },
                                    ],
                                    attrs: {
                                      icon: "el-icon-delete",
                                      title: "Delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(row)
                                      },
                                    },
                                  }),
                                ],
                              ],
                              2
                            )
                          : _vm._e(),
                        row.Status === 1
                          ? _c(
                              "OptionMenu",
                              {
                                attrs: {
                                  icon: "iconfont icon-more-menu",
                                  iconSize: "18",
                                },
                              },
                              [
                                [
                                  _c("OptionMenuItem", {
                                    directives: [
                                      {
                                        name: "role",
                                        rawName: "v-role",
                                        value: [2, 3, 5, 7, 9, 11, 13],
                                        expression: "[2, 3, 5, 7, 9, 11, 13]",
                                      },
                                    ],
                                    attrs: {
                                      icon: "el-icon-refresh-left",
                                      title: "Recall",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRecall(
                                          row.MessageHeadID
                                        )
                                      },
                                    },
                                  }),
                                ],
                              ],
                              2
                            )
                          : _vm._e(),
                        row.Status === 2 && row.AdandamCount < 3
                          ? _c(
                              "OptionMenu",
                              {
                                attrs: {
                                  icon: "iconfont icon-more-menu",
                                  iconSize: "18",
                                },
                              },
                              [
                                _c("OptionMenuItem", {
                                  attrs: {
                                    icon: "el-icon-plus",
                                    title: "Add Comment",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAddAdandam(row)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticClass: "pagination-wrap" }, [
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 25, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("CombinePushDialog", {
        attrs: { visible: _vm.combinePushDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.combinePushDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("NewPushDialog", {
        attrs: { visible: _vm.newPushDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.newPushDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("EditPushDialog", {
        attrs: { visible: _vm.editPushDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.editPushDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("QuickPushDialog", {
        attrs: { visible: _vm.quickPushDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.quickPushDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("EditQuickPushDialog", {
        attrs: { visible: _vm.editQuickPushDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.editQuickPushDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("NewMeetingDialog", {
        attrs: { visible: _vm.newMeetingDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.newMeetingDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("EditMeetingDialog", {
        attrs: { visible: _vm.editMeetingDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.editMeetingDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("AddAdandamDialog", {
        attrs: { visible: _vm.addAdandamDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.addAdandamDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _vm.editorPreloaded
        ? _c("TinymceEditor", {
            staticStyle: {
              position: "absolute",
              left: "-9999px",
              opacity: "0",
              "pointer-events": "none",
            },
            attrs: { height: 0 },
            model: {
              value: _vm.editorPreloadContent,
              callback: function ($$v) {
                _vm.editorPreloadContent = $$v
              },
              expression: "editorPreloadContent",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }